import { ChannelManager } from '@ayocore/erp/crm/client/components/ChannelManager';
import type { ContactChannel } from '../../../../../schemas/contact-channel.schema';

interface PartnerChannelsProps {
  entityUuid: string;
  contactChannels: ContactChannel[];
  onChannelsChanged: () => void;
}

export function PartnerChannels({
  entityUuid,
  contactChannels,
  onChannelsChanged,
}: PartnerChannelsProps) {
  return (
    <ChannelManager
      entityUuid={entityUuid}
      contactChannels={contactChannels}
      onChannelsChanged={onChannelsChanged}
    />
  );
}
